
import { GameState } from '../../GameContextTypes';

// Calculate KPI improvements based on career level
export const getCareerLevelMultiplier = (careerLevel: string): number => {
  const careerLevelMultipliers = {
    'Junior': 1,
    'Mid-Level': 1.2,
    'Senior': 1.5,
    'Leader': 1.8,
    'Expert': 2.0
  };
  
  return careerLevelMultipliers[careerLevel] || 1;
};

// Calculate base KPI improvements with diminishing returns
export const calculateBaseKpiImprovements = (state: GameState, careerMultiplier: number) => {
  const { kpis } = state;
  
  // Calculate diminishing returns for each KPI as they approach their max values
  const uptimeHeadroom = Math.max(0.1, (100 - kpis.uptime) / 10);
  const uptimeImprovement = uptimeHeadroom * 0.3 * careerMultiplier * (0.8 + Math.random() * 0.4);
  
  const energyCostHeadroom = Math.max(0.0005, (kpis.energyCost - 0.03) / 0.1);
  const energyCostReduction = energyCostHeadroom * 0.003 * careerMultiplier * (0.8 + Math.random() * 0.4);
  
  const profitMarginHeadroom = Math.max(0.1, (40 - kpis.profitMargin) / 10);
  const profitMarginImprovement = profitMarginHeadroom * 0.4 * careerMultiplier * (0.8 + Math.random() * 0.4);
  
  const efficiencyHeadroom = Math.max(0.1, (95 - kpis.efficiency) / 10);
  const efficiencyImprovement = efficiencyHeadroom * 0.5 * careerMultiplier * (0.8 + Math.random() * 0.4);
  
  return {
    uptimeImprovement,
    energyCostReduction,
    profitMarginImprovement,
    efficiencyImprovement
  };
};

// Apply role-specific KPI bonuses
export const applyRoleSpecificKpiBonuses = (kpis: GameState['kpis'], roleId: string, careerMultiplier: number) => {
  const updatedKpis = { ...kpis };
  
  switch (roleId) {
    case 'technician':
      updatedKpis.uptime += 0.3 * careerMultiplier;
      updatedKpis.efficiency += 0.1 * careerMultiplier;
      break;
    case 'engineer':
      updatedKpis.efficiency += 0.4 * careerMultiplier;
      updatedKpis.uptime += 0.15 * careerMultiplier;
      break;
    case 'energy':
      updatedKpis.energyCost = Math.max(0.03, updatedKpis.energyCost - (0.002 * careerMultiplier));
      updatedKpis.efficiency += 0.2 * careerMultiplier;
      break;
    case 'entrepreneur':
      updatedKpis.profitMargin += 0.5 * careerMultiplier;
      updatedKpis.efficiency += 0.1 * careerMultiplier;
      updatedKpis.uptime += 0.1 * careerMultiplier;
      updatedKpis.energyCost = Math.max(0.03, updatedKpis.energyCost - (0.0008 * careerMultiplier));
      break;
    case 'operations':
      updatedKpis.uptime += 0.2 * careerMultiplier;
      updatedKpis.efficiency += 0.15 * careerMultiplier;
      updatedKpis.energyCost = Math.max(0.03, updatedKpis.energyCost - (0.001 * careerMultiplier));
      updatedKpis.profitMargin += 0.2 * careerMultiplier;
      break;
  }
  
  return updatedKpis;
};
